export default "__VITE_ASSET__Qqrukcg$__"